export const environment = {
  envName: 'production',
  production: true,
  coreApiUrl: 'https://core.horseloop.no/api/v1/',
  googleMapsApiKey: 'AIzaSyC4xccGrFbVC5m87VsrandeGVkfmiUSNik',
};
